// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2CdeN","resendInfoText":"OnGoingPaymentBox_resendInfoText__3NBEf"};